import {
    CLEAR_USER, EMPTY_ACCOUNTS,
    FETCH_COMPANY, FETCH_COMPANY_SUCCESS, FETCH_COMPANY_FAILURE,
    FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURE,
    SAVE_AVATAR, SAVE_AVATAR_SUCCESS, SAVE_AVATAR_FAILURE,
    SAVE_COMPANY, SAVE_COMPANY_SUCCESS, SAVE_COMPANY_FAILURE,
    SAVE_PAYMENT_METHOD, SAVE_PAYMENT_METHOD_SUCCESS, SAVE_PAYMENT_METHOD_FAILURE,
    SAVE_SUBSCRIPTION, SAVE_SUBSCRIPTION_SUCCESS, SAVE_SUBSCRIPTION_FAILURE,
    SAVE_USER, SAVE_USER_FAILURE, SAVE_USER_SUCCESS,
    SET_COMPANY, SET_USER, UPDATE_ACCOUNTS
} from './constants';

import Request from 'utils/request';
import { PATHS } from 'utils/paths';

import { uploadFile } from 'containers/App/store/actions';
import { fetchSignupSuccess, getLoggedInUser, setAuthUser, setToken } from 'containers/Auth/store/actions';
import { LOCALSTORAGE } from 'utils/constants';

export const clearUser = () => ({
    type: CLEAR_USER
});

export const emptyAccounts = () => ({
    type: EMPTY_ACCOUNTS
});

const fetchCompany = () => ({
    type: FETCH_COMPANY
});

const fetchCompanySuccess = (data) => ({
    type: FETCH_COMPANY_SUCCESS,
    data
});

const fetchCompanyFailure = (error) => ({
    type: FETCH_COMPANY_FAILURE,
    error
});

const fetchUser = () => ({
    type: FETCH_USER
});

const fetchUserSuccess = (data) => ({
    type: FETCH_USER_SUCCESS,
    data
});

const fetchUserFailure = (error) => ({
    type: FETCH_USER_FAILURE,
    error
});

const saveAvatar = () => ({
    type: SAVE_AVATAR
});

const saveAvatarSuccess = (data) => ({
    type: SAVE_AVATAR_SUCCESS,
    data
});

const saveAvatarFailure = (error) => ({
    type: SAVE_AVATAR_FAILURE,
    error
});

const saveCompany = () => ({
    type: SAVE_COMPANY
});

const saveCompanySuccess = (data) => ({
    type: SAVE_COMPANY_SUCCESS,
    data
});

const saveCompanyFailure = (error) => ({
    type: SAVE_COMPANY_FAILURE,
    error
});

const savePaymentMethod = () => ({
    type: SAVE_PAYMENT_METHOD
});

const savePaymentMethodSuccess = (data) => ({
    type: SAVE_PAYMENT_METHOD_SUCCESS,
    data
});

const savePaymentMethodFailure = (error) => ({
    type: SAVE_PAYMENT_METHOD_FAILURE,
    error
});

const saveSubscription = () => ({
    type: SAVE_SUBSCRIPTION
});

const saveSubscriptionSuccess = (data) => ({
    type: SAVE_SUBSCRIPTION_SUCCESS,
    data
});

const saveSubscriptionFailure = (error) => ({
    type: SAVE_SUBSCRIPTION_FAILURE,
    error
});

const saveUser = () => ({
    type: SAVE_USER
});

const saveUserSuccess = (data) => ({
    type: SAVE_USER_SUCCESS,
    data
});

const saveUserFailure = (error) => ({
    type: SAVE_USER_FAILURE,
    error
});

export const setCompany = (data) => ({
    type: SET_COMPANY,
    data
});

export const setUser = (data) => ({
    type: SET_USER,
    data
});

export const updateAccounts = (data) => ({
    type: UPDATE_ACCOUNTS,
    data
});

/**
 *  ASYNC ACTIONS
 */

export const getCompanyById = (companyId) => (dispatch, getStore) => {
    dispatch(fetchCompany());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.company.getById(companyId))
        .then((response) => {
            dispatch(fetchCompanySuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getCompanyById error', error, error.response);
            error.friendlyMessage = 'There was an error getting this company. Please try again.';
            dispatch(fetchCompanyFailure(error));
            throw error;
        });
};

export const getUserById = (userId) => (dispatch, getStore) => {
    dispatch(fetchUser());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.user.getById(userId))
        .then((response) => {
            dispatch(fetchUserSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getUserById error', error, error.response);
            error.friendlyMessage = 'There was an error getting this user. Please try again.';
            dispatch(fetchUserFailure(error));
            throw error;
        });
};

export const postPutCompany = (company) => (dispatch, getStore) => {
    dispatch(saveCompany());

    if(company == null) {
        company = getStore().accounts.company;
    }


    let request = new Request(getStore().auth.token);

    let requestFunc = request.post;
    let url = PATHS.company.create();

    if(company.id != null) {
        requestFunc = request.put;
        url = PATHS.company.save(company.id);
    } else {
        company.userId = getStore().auth.user.id;
    }

    return requestFunc(url, company)
        .then((response) => {
            if(company.id != null) {
                dispatch(saveCompanySuccess(response.data.data));
                if (getStore().auth.user.company.id === response.data.data.id) {
                    dispatch(getLoggedInUser(null, false));
                }
            } else {
                dispatch(saveCompanySuccess({}));
            }
            return response;
        })
        .catch((error) => {
            console.log('postPutCompany error', error, error.response);
            error.friendlyMessage = 'There was an error saving your business.';
            dispatch(saveCompanyFailure(error));
            throw error;
        });
};

export const postPutUser = () => (dispatch, getStore) => {
    dispatch(saveUser());

    let user = getStore().accounts.user;

    let request = new Request(getStore().auth.token);

    let requestFunc = request.post;
    let url = PATHS.user.create();

    if(getStore().auth.user.isAdmin === true) {
        url = PATHS.user.adminCreate();
    }

    if(user.id != null) {
        requestFunc = request.put;
        url = PATHS.user.save();
    }

    return requestFunc(url, user)
        .then((response) => {
            if(user.id != null) {
                dispatch(saveUserSuccess(response.data.data));
                if (getStore().auth.user.id === response.data.data.id) {
                    dispatch(getLoggedInUser(null, false));
                }
            } else {
                localStorage.setItem(LOCALSTORAGE.ID_TOKEN, response.data.data.token);
                dispatch(setToken(response.data.data.token));
                dispatch(saveUserSuccess(response.data.data.user));
                dispatch(fetchSignupSuccess(response.data.data.user));

            }
            return response;
        })
        .catch((error) => {
            console.log('postPutUser error', error, error.response);
            if(error.response.status === 400) {
                error.friendlyMessage = 'That email address is in use. Please choose another or log in.';
            } else if(error.response.status === 500) {
                error.friendlyMessage = `There was an internal server error, please contact support with this error code: ${error.body ? error.body.breadcrumb : '11'}`;
            } else {
                error.friendlyMessage = 'There was an error saving your profile. ';
            }
            dispatch(saveUserFailure(error));
            throw error;
        });
};

export const postPutProfileImageChange = (objectType, data) => (dispatch, getStore) => {
    let path = PATHS.user.save();
    if(objectType === 'agency') {
        path = PATHS.company.save(data.id);
    }

    let request = new Request(getStore().auth.token);

    return request.put(path, data)
        .then((res) => {
            dispatch(saveAvatarSuccess(res));
            if(objectType === 'agency') {
                let newUserObj = getStore().accounts.user;
                newUserObj.company.profilePicUrl = data.profilePicUrl;
                dispatch(setUser(newUserObj));
                newUserObj = getStore().auth.user;
                newUserObj.company.profilePicUrl = data.profilePicUrl;
                dispatch(setAuthUser(newUserObj));
            } else {
                let newUserObj = getStore().accounts.user;
                newUserObj.profilePicUrl = data.profilePicUrl;
                dispatch(setUser(newUserObj));
                newUserObj = getStore().auth.user;
                newUserObj.profilePicUrl = data.profilePicUrl;
                dispatch(setAuthUser(newUserObj));
            }
            return res;
        })
        .catch((error) => {
            console.log('postPutProfileImageChange error', error, error.response);
            dispatch(saveAvatarFailure(error));
            throw error;
        });
}

export const putPaymentMethod = (stripeToken) => (dispatch, getStore) => {
    dispatch(savePaymentMethod());

    let company = getStore().auth.user.company;
    let request = new Request(getStore().auth.token);

    return request.put(PATHS.company.savePaymentMethod(company.id), {stripeSourceId: stripeToken})
        .then((response) => {
            console.log(response)
            dispatch(savePaymentMethodSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('putPaymentMethod error', error, error.response);
            error.friendlyMessage = 'There was an error saving your payment method. Please try again.';
            dispatch(savePaymentMethodFailure(error));
            throw error;
        });
};

export const putSubscription = (subscriptionType) => (dispatch, getStore) => {
    dispatch(saveSubscription());

    let company = getStore().auth.user.company;
    let request = new Request(getStore().auth.token);

    return request.put(PATHS.company.saveSubscription(company.id), {planName: subscriptionType})
        .then((response) => {
            console.log(response)
            dispatch(saveSubscriptionSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('putSubscription error', error, error.response);
            error.friendlyMessage = 'There was an error saving your subscription level. Please try again.';
            dispatch(saveSubscriptionFailure(error));
            throw error;
        });
};

export const uploadProfileImage = (object) => (dispatch, getStore) => {
    dispatch(saveAvatar());

    let file = getStore().accounts.user.profilePicUrl;
    if(object === 'agency') {
        file = getStore().accounts.company.profilePicUrl;
    }

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.file.getUploadUrl(file.name))
        .then((response) => {
            dispatch(uploadFile(file, response.data.data.presignedUrl, () => {
                setTimeout(() => {
                    if(object === 'user') {
                        let newUserObj = getStore().accounts.user;
                        newUserObj.profilePicUrl = response.data.data.fileUrl;
                        dispatch(postPutProfileImageChange(object, {id: newUserObj.id, profilePicUrl: newUserObj.profilePicUrl}));
                    } else {
                        let newCompanyObj = getStore().accounts.company;
                        newCompanyObj.profilePicUrl = response.data.data.fileUrl;
                        dispatch(postPutProfileImageChange(object, {id: newCompanyObj.id, profilePicUrl: newCompanyObj.profilePicUrl}));
                    }
                }, 1200);
                return response;
            }, (error) => {
                error.friendlyMessage = 'There was an error uploading your new avatar. Please try again.';
                dispatch(saveAvatarFailure(error));
                throw error;
            }));

            return response;
        })
        .catch((error) => {
            console.log('uploadProfileImage error', error, error.response);
            error.friendlyMessage = 'There was an error uploading your new avatar. Please try again.';
            dispatch(saveAvatarFailure(error));
            throw error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/Accounts/store/actions.js